module.exports = __webpack_public_path__ + "static/media/0216_Small.057ba5cd.jpg";